import React, { createContext, useContext, useEffect, useState } from "react";
import { clearSession, getStoredToken, getStoredUser, saveSession } from "../api/axios";
import AuthModal from "../components/AuthModal";

const AuthContext = createContext(null);

export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [authModal, setAuthModal] = useState({ open: false, mode: "login" });

  useEffect(() => {
    const storedUser = getStoredUser();
    const token = getStoredToken();
    if (storedUser && token) setUser(storedUser);
    setLoading(false);
  }, []);

  const login = (userData, token) => {
    saveSession(userData, token);
    setUser(userData);
  };

  const logout = () => {
    clearSession();
    setUser(null);
  };

  const openAuthModal = (mode = "login") => setAuthModal({ open: true, mode });
  const closeAuthModal = () => setAuthModal((s) => ({ ...s, open: false }));

  return (
    <AuthContext.Provider value={{ user, loading, login, logout, openAuthModal, closeAuthModal }}>
      {children}
      <AuthModal
        open={authModal.open}
        initialMode={authModal.mode}
        onClose={closeAuthModal}
        onLogin={login}
      />
    </AuthContext.Provider>
  );
}
